import React, { useEffect, useState } from 'react'
import { useGetContactNoteListPaginationQuery, useUpdateContactNoteMutation } from 'src/services/ContactServices'
import NotesTab from './NotesTab'
import { useParams } from 'react-router-dom';


const NotesTabWrapper = () => {    
    const { contactId } = useParams();
    const [notesData , setNotesData] = useState<any>() 
    const [updateContactNote , updateContactNoteInfo ] = useUpdateContactNoteMutation()

    const {data , isLoading , isFetching} = useGetContactNoteListPaginationQuery({
        limit: 10,
        searchValue: '',
        params: ["description"],
        page: 1,
        filterBy: [{
            fieldName :'contactId',
            value :[contactId]
        }],
        dateFilter: {},
        orderBy: "createdAt",
        orderByValue: -1,
        isPaginationRequired: false,
    }) 

    useEffect(()=>{
        if(!isLoading && !isFetching){
            setNotesData(data?.data)
        }

    },[data , isLoading , isFetching])

  return (
    <div>
        <NotesTab isLoading={isLoading|| isFetching} notesData={notesData} updateContactNote={updateContactNote} updateIsLoading={updateContactNoteInfo?.isLoading} />
    </div>
  )
}

export default NotesTabWrapper